export default `
  subscription OnAddCardComment($workflowId: String) {
    onAddCardComment(workflowId: $workflowId) {
      cardId
      workflowId
      id
      author {
        id
        firstname
        lastname
        picture {
          url
          file {
            key
          }
        }
      }
      text
      dateCreated
      dateUpdated
      generatedByAi
    }
  }
`
